// src/context/AppContext.js
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser]               = useState(null);  // { associateId, homeFacilityId, guidAssociateId, displayName }
  const [selection, setSelection]     = useState(null);  // { facility, department, shift, shiftDate }

  return (
    <AppContext.Provider value={{ user, setUser, selection, setSelection }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be inside AppProvider');
  return ctx;
}
